module.exports = "2"



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/vnode/version.js
// module id = 48
// module chunks = 7